export default __webpack_public_path__ + "assets/logo-diamond-65ab5bd488cf9ae27468ef250de22140.svg";